import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-comment-modal',
  templateUrl: './comment-modal.component.html',
  styleUrls: ['../modal.component.scss']
})
export class CommentModalComponent {
  @Input() comments!: Array<string>;
  @Output() readonly responseChanged = new EventEmitter();

  emitFalse(): void {
    this.responseChanged.emit(false);
  }
}
